module.exports = __webpack_public_path__ + "static/img/QQmusic.463b700f.png";